import React, { useEffect, useState } from "react";
import Header from "../../Components/Header";
import Sidebar from "../../Components/Sidebar";
import $ from "jquery";
import moment from "moment";
import { Client_Search } from "../../Configuration/API_URL";
import { Dashboard_Client_Report } from "../../Configuration/API_URL";
import {
  AESEncryption,
  ApiResDecrypt,
  checkDateRange,
  compareDate,
  noDataFound,
} from "../../CommonMethhods/CommonMethods";
import ReportTableHeader from "../../Components/ReportTables/ReportTableHeader";
import Loader from "../../Components/Common/Loader";
import TaxTable from "../../Components/ReportTables/TaxTable";
import TodateComponent from "./TodateComponent";
import FromdateComponent from "./FromdateComponent";
import { Constants, detailedTaxReportTypeOptions } from "../../CommonMethhods/Constants";
import LoaderForSearch from "../../Components/Common/LoaderForSearch";
import { toast } from "react-toastify";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";
import { useDebounce } from "../../Components/useDebounce";
import DurationChangeComponent from "./DurationChangeComponent";
import axiosInstance from "../../CommonMethhods/axiosInstance";

function TaxReportSidebar() {
  const storeToken = localStorage.getItem("ssoToken");
  const [fileType, setFileType] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [clientList, setClientList] = useState([]);
  const [clientCode, setClientCode] = useState("");
  const [loader, setLoader] = useState(false);
  const [smallLoaderExcel, setSmallLoaderExcel] = useState(false);
  const [smallLoaderPdf, setSmallLoaderPdf] = useState(false);
  const [seg, setSeg] = useState("eq");
  const [data, setData] = useState("");
  const [errorResp, setErrorResp] = useState("");
  const [nameError, setNameError] = useState("");
  const [scrollLoader, setScrollLoader] = useState(false);
  const [count, setCount] = useState();
  const [smallLoaderMail, setSmallLoaderMail] = useState(false);
  const [totalValues, setTotalValues] = useState({
    totalintraDayPl: 0,
    totalShortTrmPl: 0,
    totalLongTermPl: 0,
    totalintraDayTax: 0,
    totalShortTrmTax: 0,
    totalLongTermTax: 0,

  });
  const [errorGrid, setErrorGrid] = useState(false);
  const [totalPnl, setTotalPnl] = useState();
  const [page, setPage] = useState(1);
  const [show, setShow] = useState(false);
  const [mainError, setMainError] = useState(false);
  const [serverError, setServerError] = useState(false);
  const [selection, setSelection] = useState("taxreport");
  const [customShow, setCustomShow] = useState(false)
  const [selectDuration,setSelectDuration]=useState("")

  const [detailedTaxReportType, setDetailedTaxReportType] = useState("inclusive_all_taxes");

  const debouncedValue = useDebounce(clientCode, 1000);
  useEffect(() => {
    handleClientName(debouncedValue);
  }, [debouncedValue]);

  if (fromDate === "" || toDate === "") {
    const current = new Date();
    const CurrentYear = current.getFullYear();
    const CurrentMonth = current.getMonth();
    if (CurrentMonth < 4) {
      const newYear = `04-01-${CurrentYear - 1}`;
      const date = `${current.getMonth() + 1
        }-${current.getDate()}-${current.getFullYear()}`;
      const date1 = moment(date, "MM-DD-YYYY").format("MM-DD-YYYY");
      setFromDate(newYear);
      setToDate(date1);
    } else {
      const newYear = `04-01-${CurrentYear}`;
      const date = `${current.getMonth() + 1
        }-${current.getDate()}-${current.getFullYear()}`;
      const date1 = moment(date, "MM-DD-YYYY").format("MM-DD-YYYY");
      setFromDate(newYear);
      setToDate(date1);
    }
  }

  async function searchApiDetail(code, NoPage) {
    let payloadValue = {
      keyword: code,
      Status: "",
      PageNo: NoPage,
      PageSize: 10,
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getSearchDetail = await axiosInstance.post(
        Client_Search.Search_URL,
        `"${encPayload}"`,
      );

      const res = ApiResDecrypt(getSearchDetail?.data);
      if (res?.status === 0) {
        setCount(res?.data?.TotalCount);
        setNameError(false);
        if (page > 1) {
          setClientList((prev) => {
            return [...prev, ...res?.data?.clients];
          });
        } else {
          setClientList(res?.data?.clients);
        }
      } else {
        setNameError(res?.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setScrollLoader(false);
      setMainError(false);
    }
  }

  function handleClientName(data) {
    if (data) {
      searchApiDetail(data, 1);
      setScrollLoader(true);
      setClientList([]);
      setPage(1);
    }
  }

  useEffect(() => {
    if (page > 1) {
      searchApiDetail(clientCode, page);
    }
  }, [page]);

  const getTaxReport = async (fileView, mainLoader = false) => {
    if (fileView === "excel") {
      setSmallLoaderExcel(true);
    }
    if (fileView === "pdf") {
      setSmallLoaderPdf(true);
    }
    if (fileView === "mail") {
      setSmallLoaderMail(true);
    }
    if (mainLoader && fileView === "grid") {
      setLoader(true);
    }
    let payloadValue = {
      clientCode: clientCode,
      fromDate: fromDate,
      toDate: toDate,
      fileType: fileView,
      seg: seg,
      typeOfReport: selection,
      typeOfDetailTaxReport: selection === "detailed_taxreport" ? detailedTaxReportType : null
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getDetails = await axiosInstance.post(
        Dashboard_Client_Report.TaxReport_URL,
        encPayload,
      );
      const res = ApiResDecrypt(getDetails?.data);
      if (res?.status === 0) {
        if (fileView === "grid") {
          if (selection === "taxreport") {
            if (seg === "eq") {
              setData(res?.data?.TaxEqReport);
              setTotalValues({
                totalintraDayPl: res?.data?.totalintraDayPl,
                totalShortTrmPl: res?.data?.totalShortTrmPl,
                totalLongTermPl: res?.data?.totalLongTermPl,
                totalintraDayTax: res?.data?.totalintraDayTax,
                totalShortTrmTax: res?.data?.totalShortTrmTax,
                totalLongTermTax: res?.data?.totalLongTermTax,
              });
            } else {
              setData(res?.data?.TaxFoReport);
              setTotalPnl(res?.data?.totalProfitLoss);
            }
          }
          if (selection === "detailed_taxreport") {
            setData(res?.data);
            if (seg === "curfo") {
              setData(res?.data?.TaxFoReport);
              setTotalPnl(res?.data?.totalProfitLoss);
            }
          }
        } else if (fileView === "excel") {
          window.open(res?.data, "_self", "noopener,noreferrer");
        } else if (fileView === "pdf") {
          window.open(res?.data, "_blank", "noopener,noreferrer");
        } else {
          toast.success("Mail sent successfully");
        }
      } else {
        setData([]);
        setTotalValues({});
        if (fileView !== "grid") {
          toast.error(res?.message);
        } else {
          setErrorGrid(res?.message);
        }
      }
    } catch (error) {
      console.log(error);
      setServerError(error?.message);
      if (fileView !== "grid") {
        toast.error(error?.message);
      }
    } finally {
      setLoader(false);
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
      setSmallLoaderMail(false);
    }
  };

  const handleFromDateChange = (e) => {
    setErrorGrid(false);
    setData([]);
    let c = e.target.value;
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    setFromDate(d);
    setErrorResp(false);
    setServerError(false);
  };
  const handleToDateChange = (e) => {
    setErrorGrid(false);
    setData([]);
    let c = e.target.value;
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    setToDate(d);
    setErrorResp(false);
    setServerError(false);
  };

  function formatDate(date) {
    return moment(date, "MM-DD-YYYY").format("YYYY-MM-DD");
  }

  const handleOnClick = (e) => {
    setShow(false);
    if (clientCode) {
      if (e.target.value) {
        if(selectDuration){
        if (
          compareDate(fromDate) &&
          compareDate(toDate) &&
          checkDateRange(fromDate, toDate)
        ) {
          getTaxReport(e.target.value, true);
          setErrorResp(false);
        } else {
          setErrorResp("Please Select Correct Date");
        }
      }
      else{
        setErrorResp("Please Select Duration");
      }
    }
    } else {
      setMainError("Please Select Client Name/Code");
    }
  };

  const handleScroll = async (e) => {
    const a = e.target;
    if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight && !scrollLoader) {
      if (!(count <= 10 * page)) {
        setPage((prev) => prev + 1);
        setScrollLoader(true);
      }
    }
  };

  const handleSegmentChange = (e) => {
    setData([]);
    setErrorGrid(false);
    setSeg(e.target.value);
    setServerError(false);
  };

  const currentDate = new Date();
  const yyyy = currentDate.getFullYear();
  let mm = currentDate.getMonth() + 1;
  let dd = currentDate.getDate();
  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;
  const FormatedDate = dd + "/" + mm + "/" + yyyy;
  const DateReverse = FormatedDate.split("/").reverse().join("-");

  const handleSelectionChange = (e) => {
    setSelection(e.target.value);
    setErrorGrid(false);
    setServerError(false);
    setData([]);
  };
  const onChangeDuration=()=>{
    setErrorGrid(false);
    setData([]);
    setErrorResp(false);
    setServerError(false);
  }

  const handleDetailedTaxReportTypeChange = e => {
    setDetailedTaxReportType(e.target.value);
    setErrorGrid(false);
    setServerError(false);
    setData([]);
  }

  return (
    <>
      <Header portal={"RM"} />
      {/* <Sidebar /> */}
      <SingleSignOnSideBar />
      <main id="main-content" className="reports interest-report-wrapper">
        <div className="card-box">
          <div>
            <h2 className="report-title">{Constants.Tax_Report}</h2>
          </div>
          <div className="row input-field-wrapper">
            <div className="col-md-3 col-sm-3 col-6">
              {/* <div className="row d-flex justify-content-between"> */}
              <div>
                <div className="form-group">
                  <label className="form-label">
                    {Constants.Client_Search}
                  </label>
                  <div className="rm-custom-dropdown">
                    <input
                      type="text"
                      name="search-text"
                      className="input-st"
                      placeholder="Search here..."
                      autoComplete="off"
                      value={clientCode}
                      onChange={(e) => {
                        setClientCode(e.target.value.toUpperCase());
                        setShow(true);
                        setErrorGrid(false);
                      }}
                      onInput={(e) => {
                      const start = e.target.selectionStart;
                      const end = e.target.selectionEnd;
                      let input = e.target.value;
                      input = input
                          .toUpperCase()
                          .replace(/[^A-Z0-9\s]/g, "")
                          .replace(/\s+/g, " ")
                          .trimStart()
                          .slice(0, 100);

                      e.target.value = input;
                      e.target.setSelectionRange(start, end);
                  }}
                    />
                    <button
                      className="rm-dropdown-btn"
                      onClick={() => setShow(!show)}
                    >
                      <span className="icon-right-arrow-triangle"></span>
                    </button>
                    {show && (
                      <>
                        <ul
                          className="rm-mapping-ap border-0"
                          onScroll={(e) => handleScroll(e)}
                        >
                          {clientList &&
                            clientList.map((item, i) => (
                              <li
                                key={i}
                                className="rm-maping-item-wrapper"
                                onClick={() => {
                                  setClientCode(item?.clientCode);
                                  setShow(false);
                                }}
                              >
                                <div> {item?.clientname}</div>
                                <div> {item?.clientCode}</div>
                              </li>
                            ))}
                          {scrollLoader && !loader && (
                            <div className="loader-center">
                              <LoaderForSearch />
                            </div>
                          )}
                          {nameError && !scrollLoader && (
                            <li
                              className="rm-maping-item-wrapper"
                              style={{
                                borderBottom: "none",
                                fontSize: "12px",
                              }}
                            >
                              {nameError}
                            </li>
                          )}
                        </ul>
                      </>
                    )}
                  </div>
                  {mainError && (
                    <span style={{bottom: "-4px"}} className="dpreport to-date-error">{mainError}</span>
                  )}
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-3 col-6">
              <div className="form-group">
                <label className="form-label">Selection:</label>
                <select
                  onChange={handleSelectionChange}
                // style={{ padding: "5px" }}
                >
                  <option value="taxreport" selected>
                    Tax Report
                  </option>
                  <option value="detailed_taxreport">
                    Detailed Tax Report
                  </option>
                </select>
              </div>
            </div>

            {selection === "detailed_taxreport" && (
              <div className="col-md-3 col-sm-3 col-6">
                <div className="form-group">
                  <label className="form-label">Type:</label>
                  <select
                    onChange={handleDetailedTaxReportTypeChange}
                  >
                    {detailedTaxReportTypeOptions.map(opt => {
                      return (
                        <option key={opt.value} value={opt.value}>{opt.lable}</option>
                      )
                    })}
                  </select>
                </div>
              </div>
            )}

            <div className="col-md-3 col-sm-2 col-6">
              <div className="form-group">
                <label className="form-label">Segment:</label>
                <select onChange={handleSegmentChange}>
                  <option value="eq">Equity</option>
                  <option value="fo">Derivative</option>
                  <option value="curfo">{Constants.Currency}</option>
                  <option value="com">Commodity</option>
                  <option value="slbm">SLBM</option>
                </select>
              </div>
            </div>
            <div className="col-md-3 col-sm-3 col-6">
              <div className="form-group">
                <DurationChangeComponent
                  setCustomShow={setCustomShow}
                  setFromDate={setFromDate}
                  setToDate={setToDate}
                  onChangeDuration={onChangeDuration}
                  setSelectDuration={setSelectDuration}
                  selectDuration={selectDuration}
                />
              </div>
              {errorResp&& !selectDuration && (
                    <span className="duration-date-error">{errorResp}</span>
                  )}
            </div>
            {customShow && <div className="col-md-3 col-sm-2 col-6">
              <FromdateComponent
                fromDate={handleFromDateChange}
                formatDate={formatDate(fromDate)}
                DateReverse={DateReverse}
                clientWiseReportForCustomCalanderIcon={true}
              />
            </div>}
            {customShow && <div className="col-md-3 col-sm-2 col-6">
              <TodateComponent
                toDate={handleToDateChange}
                formatToDate={formatDate(toDate)}
                DateReverse={DateReverse}
                errorResponse={errorResp}
                clientWiseReportForCustomCalanderIcon={true}
              />
            </div>}
          </div>
          <div className="text-center search-btn-wrapper">
            <button
              value="grid"
              className="send-message"
              onClick={handleOnClick}
            >
              {Constants.Search}
            </button>
          </div>

          <div>
            <ReportTableHeader
              showEmailBtn={true}
              smallLoaderExcel={smallLoaderExcel}
              smallLoaderMail={smallLoaderMail}
              smallLoaderPdf={smallLoaderPdf}
              handleOnClick={handleOnClick}
            />
          </div>
          <div className="for-grid-section">
            {loader ? (
              <div className="loader-alignment">
                <Loader />
              </div>
            ) : data && data.length > 0 ? (
              <div>
                <TaxTable
                  data={data}
                  seg={seg}
                  totalValues={totalValues}
                  totalPnl={totalPnl}
                  selection={selection}
                  detailedTaxReportType={detailedTaxReportType}
                />
              </div>
            ) : serverError ? (
              <h4 className="report-error-message">
                {noDataFound(serverError)}
              </h4>
            ) : errorGrid ? (
              noDataFound(errorGrid)
            ) : (
              ""
            )}
          </div>
        </div>
      </main>
    </>
  );
}

export default TaxReportSidebar;
